// ==================== src/layouts/Footer.tsx ====================
import React from "react";
import { Link } from "react-router-dom";
import logoWhite from "../../assets/logo/logoiconwhite.png";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-brandNavy text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src={logoWhite} alt="Logo" className="h-5 w-auto" />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              Building blueprints for life and business through faith, systems,
              and technology...
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-white/70 hover:text-white transition text-sm"
              >
                About
              </Link>
              <Link
                to="/accelerator"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Accelerator
              </Link>
              <Link
                to="/pricing"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Pricing
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4">Resources</h4>
            <div className="flex flex-col gap-3">
              <Link
                to="free-masterclass"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Free Masterclass
              </Link>
              <Link
                to="/contact"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Contact
              </Link>
              <Link
                to="/privacy"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-white/70 hover:text-white transition text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Connect</h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:hello@adeoluadegbemi.com"
                className="text-white/70 hover:text-white transition text-sm"
              >
                hello@adeoluadegbemi.com
              </a>
              <div className="flex gap-4 mt-2">
                {/* Social Icons */}
                <a
                  href="https://facebook.com"
                  className="text-white/70 hover:text-white transition"
                  aria-label="Facebook"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://facebook.com"
                  className="text-white/70 hover:text-white transition"
                  aria-label="Twitter"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                  </svg>
                </a>
                <a
                  href="https://facebook.com"
                  className="text-white/70 hover:text-white transition"
                  aria-label="LinkedIn"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Adeolu Adegbemi — The Blueprint
              Architect. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link
                to="/privacy"
                className="text-white/60 hover:text-white text-sm transition"
              >
                Privacy
              </Link>
              <Link
                to="/terms"
                className="text-white/60 hover:text-white text-sm transition"
              >
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
